/* Const,Let & Var will be here */
export const TIME_CARD_DATAS = 'TIME_CARD_DATAS';

/* Const,Let & Var will be here */

export function timeCardDatas(project, taskCode, hours, startTime, endTime, lunchStartTime, lunchEndTime, shift, payCode) {
    return {
        type: TIME_CARD_DATAS,
        project: project,
        taskCode: taskCode,
        hours: hours,
        startTime: startTime,
        endTime: endTime,
        lunchStartTime: lunchStartTime,
        lunchEndTime: lunchEndTime,
        shift: shift,
        payCode: payCode
    };
}